var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-around bg-white"},[_c('h1',[_vm._v("Predicted Letter: "+_vm._s(_vm.display))]),_c('h1',[_vm._v("Accuracy: "+_vm._s(_vm.accuracy))])])}
var staticRenderFns = []

export { render, staticRenderFns }